import { render, staticRenderFns } from "./token.vue?vue&type=template&id=8c086d3c&scoped=true"
import script from "./token.vue?vue&type=script&lang=js"
export * from "./token.vue?vue&type=script&lang=js"
import style0 from "./token.vue?vue&type=style&index=0&id=8c086d3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c086d3c",
  null
  
)

export default component.exports